import { render, staticRenderFns } from "./SizeSelectorExtraLabel.vue?vue&type=template&id=1813f1f1&"
import script from "./SizeSelectorExtraLabel.vue?vue&type=script&lang=js&"
export * from "./SizeSelectorExtraLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports